import React, {useEffect} from 'react';
import useScreenSize from "../../helpers/hooks/useScreenSize";
import {Btn, FlexColumnSection, Header, SmallText} from "../../styles/globalStyles";
import DownloadApp from "../../components/UI/DownloadApp";
import SuccessSchedule from "../../svg/SuccessSchedule";
import SuccessRegister from "../../svg/SuccessRegister";
import SuccessPurchase from "../../svg/SuccessPurchase";
import SuccessWaiver from "../../svg/SuccessWaiver";
import SuccessShop from "../../svg/SuccessShop";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {Colors} from "@arboxappv4/shared/src/styles/Colors";
import {Divider} from "antd";
import {setTargetName} from "@arboxappv4/shared/src/redux/stepperSlice";
import {useDispatch} from "react-redux";
import {t} from "i18next";

const Success = (props) => {
    const { header, subheader, onCTAClick, ctaText, svgType, hideApp, newSuccessFormat} = props;
    const {isMobile} = useScreenSize()
    const dispatch = useDispatch()

    useEffect(() => {
        if(newSuccessFormat) {
            dispatch(setTargetName(t('success-lead-form-tab-name')))
        }
    }, [newSuccessFormat]);

    const getSVG = () => {
        switch(svgType) {
            case 'schedule':
                return <SuccessSchedule width={150}/>
            case 'register':
                return <SuccessRegister width={150}/>
            case 'membership':
                return <SuccessPurchase width={150}/>
            case 'waiver':
                return <SuccessWaiver width={150}/>
            case 'shop':
                return <SuccessShop width={150}/>
            default:
                return <SuccessShop width={150}/>
        }
    }

    return (
        <>
            {newSuccessFormat ?
                <FlexColumnSection align={'center'} width={'100%'} padding={'40px 16px'} justify={'center'}>
                    <FlexColumnSection gap={'10px'} align={'center'} flex={'none'} height={'100%'} justify={'center'}>
                        <FontAwesomeIcon icon={solid('check')} color={Colors.siteBlack} style={{ fontSize: '50px' }}/>
                        <Header>{header}</Header>
                        <SmallTextCenter>{subheader}</SmallTextCenter>
                    </FlexColumnSection>
                </FlexColumnSection>
                :
                <FlexColumnSection gap={'15px'} align={'center'} padding={'40px 16px'}>
                    {!isMobile && getSVG()}
                    <FlexColumnSection gap={'10px'} align={'center'} flex={'none'}>
                        <Header>{header}</Header>
                        <SmallTextCenter>{subheader}</SmallTextCenter>
                        {onCTAClick && <Btn type={'primary'} onClick={onCTAClick} width={isMobile ? '100%' : null}>{ctaText}</Btn>}
                    </FlexColumnSection>
                    {!hideApp &&
                        <div style={{marginTop: '20px', width: isMobile ? '100%' : 'auto'}}>
                            <DownloadApp/>
                        </div>}
                </FlexColumnSection>}
        </>
    );
};

export default Success;

const SmallTextCenter = styled(SmallText)`
    text-align: center;
`